export function debounce(fn: Function, wait: number) {
  let timer: NodeJS.Timeout;

  return function(...args: any[]) {
    clearTimeout(timer);
    timer = setTimeout(function() {
      fn.apply(null, args);
    }, wait);
  }
}